/*
 * Copyright (C) 2024 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

// this list is made of the first 25 entries from each language found in
// https://github.com/oprogramador/most-common-words-by-language/tree/master/src/resources

// it is intended to be used in low-stakes contexts (such as term highlighting)
// where we do not know the language of the document

const stopwords: string[] = [
  'a',
  'ada',
  'af',
  'aga',
  'ai',
  'això',
  'akan',
  'ako',
  'aku',
  'al',
  'ale',
  'ali',
  'all',
  'am',
  'ama',
  'amb',
  'and',
  'anda',
  'anh',
  'apa',
  'ar',
  'are',
  'as',
  'asta',
  'at',
  'att',
  'au',
  'auf',
  'az',
  'azt',
  'aš',
  'bana',
  'be',
  'bem',
  'ben',
  'bet',
  'bi',
  'bien',
  'bine',
  'bir',
  'bisa',
  'bo',
  'bom',
  'bu',
  'bunu',
  'by',
  'ca',
  'ce',
  'che',
  'cho',
  'chúng',
  'ci',
  'co',
  'com',
  'como',
  'con',
  'cosa',
  'csak',
  'cu',
  'czy',
  'có',
  'cô',
  'că',
  'của',
  'd',
  'da',
  'daha',
  'dan',
  'dans',
  'dari',
  'Das',
  'das',
  'dat',
  'de',
  'deg',
  'den',
  'dengan',
  'der',
  'des',
  'det',
  'değil',
  'dhe',
  'di',
  'dia',
  'die',
  'dig',
  'dit',
  'do',
  'du',
  'Du',
  'e',
  'een',
  'egy',
  'ei',
  'ein',
  'ek',
  'el',
  'ele',
  'els',
  'em',
  'en',
  'er',
  'es',
  'est',
  'estas',
  'este',
  'está',
  'et',
  'että',
  'eu',
  'evet',
  'ez',
  'for',
  'from',
  'för',
  'ga',
  'gaan',
  'gerai',
  'gibi',
  'go',
  'gì',
  'ha',
  'han',
  'har',
  'hayır',
  'heb',
  'het',
  'hij',
  'ho',
  'hogy',
  'hva',
  'hvad',
  'hy',
  'hän',
  'här',
  'i',
  'Ich',
  'ich',
  'igen',
  'ik',
  'ikke',
  'il',
  'ili',
  'in',
  'ini',
  'inte',
  'ir',
  'is',
  'isso',
  'ist',
  'it',
  'itt',
  'itu',
  'için',
  'iš',
  'ja',
  'jag',
  'jah',
  'jak',
  'je',
  'jeg',
  'jes',
  'jest',
  'ji',
  'jis',
  'jo',
  'jos',
  'jou',
  'jsem',
  'jsi',
  'jy',
  'já',
  'jā',
  'jūs',
  'ka',
  'kad',
  'kadar',
  'kaip',
  'kaj',
  'kami',
  'kan',
  'kas',
  'kau',
  'ke',
  'kell',
  'không',
  'kiel',
  'kio',
  'kita',
  'ko',
  'kui',
  'kuin',
  'kun',
  'kā',
  'ką',
  'l',
  'la',
  'labi',
  'lahko',
  'le',
  'Le',
  'les',
  'li',
  'lo',
  'los',
  'là',
  'làm',
  'ma',
  'maar',
  'mai',
  'man',
  'mano',
  'mas',
  'me',
  'med',
  'meg',
  'mereka',
  'mes',
  'met',
  'mi',
  'mich',
  'mida',
  'mig',
  'min',
  'minä',
  'mir',
  'mirë',
  'mis',
  'mit',
  'mitä',
  'mnie',
  'mu',
  'mund',
  'mutta',
  'my',
  'már',
  'még',
  'më',
  'mēs',
  'mě',
  'mı',
  'một',
  'n',
  'na',
  'nav',
  'nbsp',
  'ne',
  'nem',
  'nga',
  'người',
  'ni',
  'nicht',
  'nie',
  'niet',
  'nii',
  'niin',
  'nije',
  'një',
  'no',
  'non',
  'not',
  'nu',
  'nuk',
  'nyt',
  'này',
  'não',
  'në',
  'nē',
  'o',
  'och',
  'od',
  'of',
  'og',
  'ole',
  'oled',
  'olen',
  'olet',
  'oli',
  'om',
  'oma',
  'on',
  'ons',
  'op',
  'or',
  'ovo',
  'pa',
  'par',
  'para',
  'pas',
  'pe',
  'pentru',
  'per',
  'pero',
  'phải',
  'plus',
  'po',
  'pole',
  'por',
  'pour',
  'pri',
  'på',
  'për',
  'que',
  'qui',
  'què',
  'qué',
  'që',
  'rồi',
  's',
  'sa',
  'sam',
  'samo',
  'saya',
  'se',
  'sed',
  'seda',
  'see',
  'sem',
  'sen',
  'si',
  'Sie',
  'sie',
  'siis',
  'sinä',
  'sitä',
  'się',
  'sme',
  'so',
  'som',
  'sono',
  'ste',
  'su',
  'sunt',
  'sur',
  'sy',
  'så',
  'să',
  'sẽ',
  'ta',
  'tahu',
  'tai',
  'taip',
  'tak',
  'tapi',
  'tas',
  'tau',
  'te',
  'tego',
  'tev',
  'that',
  'the',
  'this',
  'ti',
  'tidak',
  'tie',
  'tik',
  'til',
  'tio',
  'to',
  'tu',
  'ty',
  'tym',
  'tämä',
  'të',
  'tôi',
  'tā',
  'u',
  'um',
  'uma',
  'un',
  'una',
  'und',
  'une',
  'untuk',
  'unë',
  'uz',
  'už',
  'v',
  'va',
  'vad',
  'vagy',
  'vai',
  'vain',
  'van',
  'var',
  've',
  'vi',
  'vin',
  'vir',
  'viņš',
  'você',
  'voi',
  'volt',
  'voor',
  'và',
  'w',
  'Was',
  'was',
  'wat',
  'we',
  'wir',
  'with',
  'y',
  'ya',
  'yang',
  'yok',
  'you',
  'your',
  'z',
  'za',
  'ze',
  'zijn',
  'zu',
  'áno',
  'är',
  'ära',
  'å',
  'çfarë',
  'çok',
  'è',
  'é',
  'én',
  'és',
  'është',
  'în',
  'ĉi',
  'ĉu',
  'če',
  'čia',
  'čo',
  'đi',
  'đây',
  'đã',
  'đó',
  'được',
  'į',
  'şey',
  'şi',
  'šta',
  'što',
  'że',
  'že',
  'από',
  'αυτό',
  'για',
  'δεν',
  'είναι',
  'η',
  'θα',
  'και',
  'με',
  'μου',
  'να',
  'ο',
  'που',
  'σε',
  'σου',
  'στο',
  'τα',
  'την',
  'της',
  'τι',
  'το',
  'τον',
  'του',
  'ότι',
  'όχι',
  'а',
  'аз',
  'ба',
  'бар',
  'бе',
  'біз',
  'бұл',
  'в',
  'во',
  'все',
  'вы',
  'ги',
  'го',
  'да',
  'де',
  'дека',
  'деп',
  'добре',
  'добро',
  'е',
  'его',
  'емес',
  'жақсы',
  'жоқ',
  'з',
  'за',
  'и',
  'иә',
  'как',
  'какво',
  'како',
  'керек',
  'ли',
  'ма',
  'маған',
  'мен',
  'меня',
  'мені',
  'менің',
  'ми',
  'мне',
  'мы',
  'на',
  'не',
  'нет',
  'но',
  'ова',
  'од',
  'ол',
  'олар',
  'он',
  'она',
  'оны',
  'оның',
  'от',
  'с',
  'се',
  'сен',
  'си',
  'со',
  'сум',
  'съм',
  'сіз',
  'так',
  'те',
  'тебе',
  'тебя',
  'ти',
  'тоа',
  'това',
  'трябва',
  'ты',
  'у',
  'це',
  'че',
  'что',
  'што',
  'ще',
  'що',
  'это',
  'я',
  'і',
  'ја',
  'јас',
  'ќе',
  'үшін',
  'אבל',
  'אם',
  'אני',
  'את',
  'אתה',
  'בסדר',
  'הוא',
  'היא',
  'היה',
  'זה',
  'טוב',
  'יודע',
  'יש',
  'כל',
  'כן',
  'לא',
  'לי',
  'לך',
  'מה',
  'על',
  'עם',
  'רוצה',
  'של',
  'שלי',
  'שלך',
  'أن',
  'أنا',
  'أنت',
  'إلى',
  'از',
  'ان',
  'اون',
  'اين',
  'با',
  'باشه',
  'بايد',
  'براي',
  'به',
  'بود',
  'تا',
  'تو',
  'خيلي',
  'در',
  'ذلك',
  'رو',
  'على',
  'عن',
  'في',
  'كان',
  'لا',
  'لقد',
  'لم',
  'ما',
  'ماذا',
  'من',
  'مي',
  'نعم',
  'نه',
  'ها',
  'هذا',
  'هذه',
  'هل',
  'هم',
  'هنا',
  'هناك',
  'هو',
  'و',
  'يا',
  'يه',
  'چي',
  'کنم',
  'که',
  'अगर',
  'अब',
  'आ',
  'आप',
  'इस',
  'उस',
  'एक',
  'एम',
  'ओह',
  'और',
  'कर',
  'घर',
  'जब',
  'तक',
  'तरह',
  'पर',
  'बस',
  'मत',
  'मतलब',
  'यह',
  'वह',
  'सब',
  'समय',
  'हम',
  'हर',
  'আজ',
  'আর',
  'উপর',
  'এ',
  'এই',
  'এক',
  'একজন',
  'এখন',
  'এমন',
  'এর',
  'ঐ',
  'ও',
  'ওই',
  'ওর',
  'ওহ',
  'কর',
  'নয়',
  'বছর',
  'বড়',
  'মত',
  'যখন',
  'সব',
  'সময়',
  'হল',
  'হয়',
  'ทำไม',
  'บรรยายไทยโดย',
  'อะไร',
  'อะไรนะ',
  'เธ',
  'เธญเธ',
  'เธฑเธ',
  'เธฒเธ',
  'เธตเน',
  'เน',
  'และ',
  'โอ',
  'โอเค',
  'ไป',
  'ๆ',
  'い',
  'う',
  'か',
  'が',
  'く',
  'し',
  'す',
  'た',
  'だ',
  'っ',
  'て',
  'で',
  'と',
  'な',
  'に',
  'の',
  'は',
  'ま',
  'も',
  'よ',
  'ら',
  'る',
  'を',
  'ん',
  '一',
  '不',
  '了',
  '什么',
  '他',
  '你',
  '去',
  '吗',
  '吧',
  '在',
  '她',
  '好',
  '就',
  '很',
  '想',
  '我',
  '我们',
  '是',
  '有',
  '的',
  '知道',
  '私',
  '要',
  '说',
  '这',
  '那',
  '거야',
  '그',
  '그래',
  '그리고',
  '난',
  '내',
  '내가',
  '네',
  '다',
  '더',
  '수',
  '안',
  '왜',
  '우리',
  '이',
  '있어',
  '잘',
  '좀',
  '한',
  '할',
]

export default stopwords
